import { BaseService } from './BaseService';
import axios, { AxiosResponse } from 'axios';
import { SchoolDataResponse } from './types/school';
export * from './types/school';

export default class SchoolService extends BaseService {
    constructor() {
        super('identity/university', true);
    }

    // Methods that require API calls
    async getAllSchools(): Promise<SchoolDataResponse[]> {
        return axios({
            url: this.getUrl(''),
            method: 'GET',
        }).then((data: AxiosResponse<SchoolDataResponse[]>) => {
            return data.data;
        });
    }

    async getSchoolDataById(id: number): Promise<SchoolDataResponse> {
        return axios({
            url: this.getUrl(`${id}`),
            method: 'GET',
        }).then((data: AxiosResponse<SchoolDataResponse>) => {
            return data.data;
        });
    }
}
